<template>
  <div id="page" class="container-fluid pq-container">

  <b-modal :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Modules
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>

    <div class="container-fluid">
      <div class="row mt-2 pb-2 header-row orange status-header-row">
        <div class="col-4">Module</div>
        <div class="col-4">Status</div>
        <div class="col-4">Time</div>
      </div>
      <div class="row justify-content-center m-2">
        <div class="alert alert-danger col-6" role="alert" v-show="generalErrorMessage">
          <div>{{ generalErrorMessage }}</div>
        </div>
      </div>
      <div v-for="module in statuses" :key="module.moduleName" class="row data-row align-items-center">
        <div class="col-4">{{ module.moduleName }}</div>
        <div class="col-4">{{ statusString(module.complete) }}</div>
        <div class="col-4">{{ formatDateTime(module.updatedAt) }}</div>
      </div>
    </div>

    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>

  <loading-modal :visible="showingLoadingModal" @update:visible="visible => showingLoadingModal = visible"></loading-modal>
  </div>
</template>

<script>
  import api from '../services/api'
  import LoadingModal from '../components/LoadingModal'
  import moment from 'moment-timezone'
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'VisitIntakeModuleStatusModal',

    components: { LoadingModal },

    mixins: [ErrorsMixin, AnalyticsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      sessionId: {
        type: String,
        required: true
      }
    },

    data () {
      return {
        showingLoadingModal: false,
        statuses: []
      }
    },

    watch: {
      visible (newValue, oldValue) {
        if (newValue) {
          this.clearData()
        }
      }
    },

    methods: {
      clearData () {
        this.statuses = []
        this.loadStatuses()
      },

      closeModal () {
        this.$emit('update:visible', false)
      },

      loadStatuses () {
        this.showingLoadingModal = true

        this.errors = []
        api.get('/Dashboard/SessionModuleDetail/' + this.sessionId).then(response => {
          this.trackEvent('Visit', 'IntakeModuleStatus', 'Show', this.visitId)
          this.showingLoadingModal = false
          this.statuses = response.data
        }).catch(error => {
          this.showingLoadingModal = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'IntakeModuleStatus', error.message)
            this.$log.error('Error attempting to load VisitIntakeModuleStatus: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        })
      },

      statusString (completed) {
        if (completed) {
          return 'Complete'
        } else {
          return 'Incomplete'
        }
      },

      formatDateTime (date) {
        return moment(date).format('h:mm a')
      }
    },

    created () {
      if (this.sessionId) {
        this.loadStatuses()
      }
    }
  }
</script>

<style scoped>

.status-header-row {
  font-weight: bold;
  font-size: 1.2em;
}
</style>
